import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Clock } from "lucide-react";
import { api } from "@/lib/api";
import { Loading } from "@/components/Loading";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [state, setState] = useState({ status: "checking" });

  useEffect(() => {
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") return setState({ status: "paid", ...data });
        setState({ status: "waiting", ...data });
      } catch {
        setState({ status: "waiting" });
      }
      if (++tries < 30) timer = setTimeout(poll, 2500);
      else setState((s) => ({ ...s, status: "slow" }));
    };
    poll();
    return () => clearTimeout(timer);
  }, [sid]);

  if (state.status === "checking") return <Loading text="Confirming your payment with Stripe..." />;
  const paid = state.status === "paid";
  return (
    <div className="mx-auto max-w-2xl px-4 py-14 text-center" data-testid="payment-result-page">
      <div className="paper-card p-8 sm:p-12">
        {paid ? <CheckCircle2 size={72} className="mx-auto text-[#2E6930]" /> : <Clock size={72} className="mx-auto text-[#D97706]" />}
        <h1 className="mt-6 text-4xl font-bold text-[#4A2A18]" data-testid="payment-result-heading">{paid ? "Thank you! Your order is confirmed." : "We're confirming your payment..."}</h1>
        <p className="mt-4 text-lg leading-relaxed text-[#4A3B32]">
          {paid ? "We're now preparing your video and stickers. We'll show every step on your order page." : state.status === "slow" ? "This is taking longer than usual. Your order page will update as soon as Stripe confirms payment." : "This usually takes a few seconds. Please keep this page open."}
        </p>
        {state.order_id && <Link to={`/orders/${state.order_id}`} className="btn-primary mt-8 w-full" data-testid="view-order-status-button">See my order status</Link>}
      </div>
    </div>
  );
}
